import React, { useEffect } from "react";
import MenuBar from "../../components/atoms/menuBar/MenuBar";
import { ROOT, CONTACT_PATH } from "../../router/Routes";
import "./home.css";
import ReactTypingEffect from "react-typing-effect";
import { ContactUsCard } from "../../components/atoms/cards/Cards";

const AboutMe = ({ history }) => {
  useEffect(() => {
    document.title = "Aglocol";
  }, []);

  const changingText = [
    "el medio ambiente.",
    "la calidad.",
    "la eficiencia.",
    "nuestros clientes.",
  ];

  const navigateContact = () => {
    history.push(CONTACT_PATH);
  };

  return (
    <div className="main-container home-background">
      <MenuBar view={ROOT} />
      <div className="view-content">
        <div className="animated-text-container home-content">
          <div className="home-child-container">
            <span>
              Comprometidos <br /> con
              <ReactTypingEffect
                speed={100}
                eraseDelay={500}
                typingDelay={300}
                className="dynamic-text"
                text={changingText}
              />
            </span>
            <div className="br-div"/>
          </div>

          <div className="info-container">
            <div className="left-container">
              Solo distribuimos marcas líderes, cuyos tableros son fabricados
              con maderas provenientes de bosques cultivados
            </div>
            <div className="right-container">
              <ContactUsCard
                text="Tienes una idea?"
                cta="Hablemos"
                callback={navigateContact}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
